import { React, PropTypes, Skeleton, get, isString } from '../dependencies';

import MenuItem from './MenuItem';
import ImageMenu from './ImageMenu';
import NoMenuMessage from './NoMenuMessage';

const Menu = ({ isLoading, menu, isPristine }) => (
    <Skeleton loading={isLoading || (!menu && isPristine)} active={isLoading}>
        {Array.isArray(menu) && menu.map((menuItem, idx) => <MenuItem key={`item${idx}`} data={menuItem} />)}
        {isString(menu) && <ImageMenu data={menu} />}
        {get(menu, 'length', 0) === 0 && <NoMenuMessage />}
    </Skeleton>
);

Menu.propTypes = {
    menu: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
    isLoading: PropTypes.bool.isRequired,
    isPristine: PropTypes.bool.isRequired,
};

Menu.defaultProps = {
    menu: null,
};

export default Menu;
